/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuService} from "./menu.service";
import {MenuProviderHandler} from "./helpers/menu-provider-handler";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: []
})
export class MenuProviderModule {
    static forRoot(): ModuleWithProviders<MenuProviderModule> {
        return {
            ngModule: MenuProviderModule,
            providers: [
                MenuService,
                MenuProviderHandler
            ]
        }
    }
}
